module.exports = __webpack_public_path__ + "img/neck.82d4a364.svg";